import React, { createContext, useState, useEffect, useContext } from 'react';
import { accommodationsApi } from '../api/client';

const AccommodationContext = createContext();

export function AccommodationProvider({ children }) {
  const [accommodations, setAccommodations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadAccommodations() {
      try {
        setLoading(true);
        // Fetch guesthouse-visible rooms from backend API
        const data = await accommodationsApi.listGuesthouse();

        const transformedData = (data || []).map(room => ({
          ...room,
          price_per_night: room.price_per_night ? parseFloat(room.price_per_night) : null,
          photos_storage_path: room.photos_storage_path || null,
        }));

        setAccommodations(transformedData);
      } catch (err) {
        setError(`Failed to load accommodations: ${err.message}`);
        console.error("Error fetching accommodations:", err);
      } finally {
        setLoading(false);
      }
    }

    loadAccommodations();
  }, []);

  return (
    <AccommodationContext.Provider value={{ accommodations, loading, error }}>
      {children}
    </AccommodationContext.Provider>
  );
}

export function useAccommodations() {
  return useContext(AccommodationContext);
}
